module.exports = __webpack_public_path__ + "img/TheExchange-TRX-Farsya.A-133.4a619f8d.jpg";